<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :after-save="afterSave"
    :model="model"
    :rules="rules"
    :readonly="readonly"
  >
    <template slot="form" v-if="model">
      <form-section>
        <el-row>
          <el-col :span="24">
            <rest-form-item :label="$t('Metrics_Field_Title')" prop="title">
              <el-input v-model="model.title" :disabled="!isCreatePage" />
            </rest-form-item>
            <rest-form-item :label="$t('Metrics_Field_Name')" prop="name">
              <el-input v-model="model.name" />
            </rest-form-item>
            <rest-form-item :label="$t('Metrics_Field_Unit')" prop="unit">
              <el-input v-model="model.unit" />
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage'
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormSection from '@/common/components/form/FormSection'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'MetricFormPage',

  components: {
    RestFormPage,
    RestFormItem,
    FormSection
  },

  data() {
    return {
      model: this.defaultModel()
    }
  },

  props: {
    readonly: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'get',
          url: `metrics/${this.$route.query.id}`,
          handler: data => {
            this.model = data
          }
        })
      } else {
        return null
      }
    },

    saveEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'patch',
          url: `metrics/${this.$route.query.id}`
        })
      } else {
        return projectEndpoint({
          method: 'post',
          url: `metrics`
        })
      }
    },

    rules() {
      return {
        title: {
          required: true
        }
      }
    },

    isCreatePage() {
      return !this.$route.query.id
    }
  },

  methods: {
    defaultModel() {
      if (this.$route.query.id) {
        return null
      } else {
        return {}
      }
    },

    afterSave() {
      this.$router.push(
        projectRoute({
          name: 'Metrics'
        })
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/metrics/pages/MetricFormPage.vue